module.exports = __webpack_public_path__ + "static/media/Follower_Button-3.7bd26729.png";